export default "__VITE_ASSET__eEk63efi__"